<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border">
      <app-mtrki07 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-mtrki07>
    </div>
    }
    @if(detailVisible){
    <div class="top-1 border border-green-400">
    </div>
    }
  </div>
<div>
